import { Flex, BoxV2 as Box, RoleGuard } from 'portal-commons';
import React from 'react';
import { faTrash, faPen } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { TableRow, TableCell } from '@material-ui/core';

import { UserData } from '../../types';
import { parseRoleLabel } from '../../utils';
import { convertTimeWithTimezone } from '../../../../utils/time';
import { Role } from '../../../../types';

interface Props {
  user: UserData;
  key: string;
  onEditUser: (user: UserData) => void;
  onDeleteUser: (user: UserData) => void;
}

const UsersListingRow: React.FC<Props> = ({
  user,
  onEditUser,
  onDeleteUser,
}) => {
  return (
    <TableRow data-testid="usersListingRow">
      <TableCell align="left" data-testid="usersListingRowFullName">
        {user.profile.fullName}
      </TableCell>
      <TableCell align="left" data-testid="usersListingRowEmail">
        {user.profile.email}
      </TableCell>
      <TableCell align="left" data-testid="usersListingRowUserId">
        {user.profile.dcaUid}
      </TableCell>
      <TableCell align="left" data-testid="usersListingRowRole">
        {parseRoleLabel(user.profile.dcaUserRole?.[0] ?? Role.Viewer)}
      </TableCell>
      <TableCell align="left" data-testid="usersListingRowCreatedDate">
        {convertTimeWithTimezone(user.created, 'MM/DD/YYYY')}
      </TableCell>
      <TableCell align="left" data-testid="usersListingRowLastLogin">
        {convertTimeWithTimezone(user.lastLogin, 'MM/DD/YYYY')}
      </TableCell>
      <TableCell
        align="right"
        data-testid="usersListingRowAction"
        style={{ width: 40 }}
      >
        <Flex
          sx={{
            alignItem: 'center',
            justifyContent: 'flex-end',
            gap: 'xxs',
            marginRight: 'l',
          }}
        >
          <RoleGuard feature="profile.editUser">
            <Box
              px="xxs"
              sx={{ cursor: 'pointer' }}
              onClick={() => onEditUser(user)}
              data-testid="usersListingRowEditButton"
            >
              <FontAwesomeIcon icon={faPen} />
            </Box>
          </RoleGuard>
          <RoleGuard feature="profile.deleteUser">
            <Box
              px="xxs"
              sx={{ cursor: 'pointer' }}
              onClick={() => onDeleteUser(user)}
              data-testid="usersListingRowDeleteButton"
            >
              <FontAwesomeIcon icon={faTrash} />
            </Box>
          </RoleGuard>
        </Flex>
      </TableCell>
    </TableRow>
  );
};

export default UsersListingRow;
